import { useCallback } from "react";
import { useRouter } from "next/router";
import { useForm, FormProvider } from "react-hook-form";
import { MainTemplate } from "@/components/templates";
import { ChangeToAdminSendMailForm } from "@/components/organisms";
import { PageTitle } from "@/components/molecules";
import { useApplyForChangeToAdminMutation } from "@/generated/graphql";
import useRollbarUtil from "../hooks/useRollbarUtil";

type FormValues = {
  email: string;
};

type Props = {
  sub: string;
};

export const ApplyForChangeToAdminPage = ({ sub }: Props) => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();
  const router = useRouter();

  const methods = useForm<FormValues>({
    reValidateMode: "onBlur",
    defaultValues: {
      email: "",
    },
  });

  const [applyForChangeToAdminMutation] = useApplyForChangeToAdminMutation({
    onCompleted: (data) => {
      if (data.applyForChangeToAdmin) {
        router.push("/change-to-admin-send-mail-completed");
      }
    },
    onError: getNotifyErrorHandlerForGraphQL(
      "Failed to apply for send change to admin",
      "メールの送付に失敗しました"
    ),
  });

  const handleSubmit = useCallback(
    async ({ email }: FormValues) => {
      await applyForChangeToAdminMutation({
        variables: {
          input: {
            sub,
            email,
          },
        },
      });
    },
    [applyForChangeToAdminMutation]
  );

  return (
    <MainTemplate title={`管理者へ変更`}>
      <PageTitle
        mainTitle={`管理者へ変更`}
        subTitle={
          <>
            管理者へ権限変更する為にはメールアドレスの認証が必要です
            <br />
            メールアドレスを入力して、受信したメールから認証してください
          </>
        }
      />
      <FormProvider {...methods}>
        <ChangeToAdminSendMailForm onSubmit={handleSubmit} />
      </FormProvider>
    </MainTemplate>
  );
};
